var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_box",style:({ height: _vm.hVal, })},[_vm._m(0),_c('div',{staticClass:"empty_name"},[_vm._v(_vm._s(_vm.TextVal))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_img"},[_c('img',{attrs:{"src":require("@/assets/images/empty.png"),"alt":""}})])
}]

export { render, staticRenderFns }